/**
 * Display rules for numeric values in the hero "ring" panel.
 *
 * @param {number} n
 * @param {{ allowTimeFormat?: boolean }} [opts] - When true, values matching `^\d{1,2}\.\d{2}$` render as `H:MM` (e.g. ROI).
 * @returns {string}
 */
export function formatHeroRingValue(n, opts = {}) {
  const { allowTimeFormat = false } = opts;
  if (!Number.isFinite(n)) return "0";

  const neg = n < 0;
  const v = Math.abs(n);
  const absFixed = v.toFixed(2);
  const [intPart, decPart = ""] = absFixed.split(".");

  if (allowTimeFormat && /^\d{1,2}\.\d{2}$/.test(absFixed)) {
    return (neg ? "-" : "") + absFixed.replace(/^(\d{1,2})\.(\d{2})$/, "$1:$2");
  }

  if (/^\d+\.00$/.test(absFixed)) {
    return (neg ? "-" : "") + intPart;
  }

  if (intPart.length >= 4) {
    return (neg ? "-" : "") + String(Math.round(v));
  }

  return (neg ? "-" : "") + absFixed.replace(/^(\d+)\.(\d).*/, "$1.$2");
}
